import { FormBase } from 'core/components';

export default class CorporateEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'CORPORATE.EDIT.NAME_LABEL',
                    placeholder: 'CORPORATE.EDIT.NAME_PLACEHOLDER',
                    rules: 'string|required'
                },                
                {
                    name: 'reportingIntervalTypeId',
                    label: 'CORPORATE.EDIT.REPORTING_INTERVAL_TYPE_LABEL',
                    placeholder: 'CORPORATE.EDIT.REPORTING_INTERVAL_TYPE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'reportingInstructions',
                    label: 'CORPORATE.EDIT.REPORTING_INSTRUCTIONS_LABEL',
                    placeholder: 'CORPORATE.EDIT.REPORTING_INSTRUCTIONS_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'specialRequests',
                    label: 'CORPORATE.EDIT.SPECIAL_REQUESTS_LABEL',
                    placeholder: 'CORPORATE.EDIT.APPROVAL_REQUIRED_EXTRA_SUPPLIES_LABEL',
                    rules: 'string'
                },
                {
                    name: 'approvalRequiredExtraSupplies',
                    type: 'checkbox',
                    default: false
                },
                {
                    name: 'specialOrders',
                    type: 'checkbox',
                    default: false
                },
                {
                    name: 'requiredSecondPayor',
                    type: 'checkbox',
                    default: false
                },
                {
                    name: 'isActive',
                    type: 'checkbox',
                    default: false
                },
                {
                    name: 'description',
                    label: 'CORPORATE.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'CORPORATE.EDIT.DESCRIPTION_PLACEHOLDER',
                    rules: 'string'
                },
            ],
        };
    }
}
